const version = process.env.VERSION;
const config = {
    version,
    froalaLicenceKey: 'aLF3c1A7C7B5F3E3F2I2xROKLJKYHROLDXDRH1e1YYGRe1Bg1G3I3A2B4D6A3B2E4E2D2==',
};
console.log(`******** PLUGIN APP (${version}) *********`);
export default config;
